import api from './api';
import { Saint, PaginatedResponse } from '../types';
export interface SaintFilters { page?: number; limit?: number; search?: string; }
const saintsService = {
  getList: async (filters: SaintFilters = {}): Promise<PaginatedResponse<Saint>> => {
    const params = new URLSearchParams();
    if (filters.page) params.append('page', String(filters.page));
    if (filters.limit) params.append('limit', String(filters.limit));
    if (filters.search) params.append('search', filters.search);
    return (await api.get(`/saints?${params.toString()}`)).data;
  },
  getById: async (id: number): Promise<Saint> => (await api.get(`/saints/${id}`)).data.data,
  create: async (data: any): Promise<Saint> => (await api.post('/saints', data)).data.data,
  update: async (id: number, data: any): Promise<Saint> => (await api.put(`/saints/${id}`, data)).data.data,
  delete: async (id: number): Promise<void> => { await api.delete(`/saints/${id}`); },
};
export default saintsService;
